<template>
  <v-container fluid>
    <v-row align="center">
      <v-col cols="12" sm="6">
        <h1>CLIENTS(All)</h1>
      </v-col>

      <v-col cols="12" sm="4">
       <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="search"
        hide-details
        ></v-text-field>
        </v-col>


      <v-col class="d-flex" cols="12" sm="2">
       <div class="my-8">
         <AddClient/>
       </div>
      </v-col> 
    </v-row>   
    <hr/>
    <v-data-table
    :headers="headers"
    :items="allclients"
    :search="search"
    class="elevation-1"
  >


    <template v-slot:item.action="{ item }">
      <div class="w-180">
      <EditClient :clientid="item.id" class="mx-2"/>
      <ShowClientProject :client="item" class="mx-2"/>
      </div>
    </template>
   
  </v-data-table>

  </v-container>
</template>
<style>
a {
  text-decoration: none;
}
.w-180{
  width:220px;
}
</style>
<script>
import { mapGetters } from 'vuex';
import AddClient from './AddClient.vue';
import EditClient from './EditClient.vue';
import ShowClientProject from './ShowClientProject';
  export default {
  components: {
    AddClient,
    EditClient,
    ShowClientProject
    },
    
    data () {
      return {
        headers: [
          {
            text: 'Client Name',
            align: 'start',
            sortable: false,
            value: 'name',
          },
          { text: 'email', value: 'email' },
          { text: 'mobile no.', value: 'mobile' },
          { text: 'gst', value: 'gst' },
          { text: 'address', value: 'address' },
          { text: 'action', value: 'action' },
        ],
        search: '',
      }
    },
    computed: {
      ...mapGetters(["allclients"]),
    },
  }
</script>